import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListCommunities from './list-communities';
import CreateCommunity from './create-community';
import CommunityDetail from './community-detail';
import EditCommunity from './edit-community';
import CommunityTagsManager from './community-tags';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const CommunityManagementRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/list-communities" element={<ListCommunities />} />
            <Route path="/create-community" element={<CreateCommunity />} />
            <Route path="/community-detail/:id" element={<CommunityDetail />} />
            <Route path="/edit-community/:id" element={<EditCommunity />} />
            <Route path="/community-tags" element={<CommunityTagsManager />} />
            <Route path="/" element={<ListCommunities />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default CommunityManagementRoutes;
